import { DEFAULT_REGION_BANK_HEADER_VALUE } from '@/constants/orders'
import type {
  PriceSegmentOptions,
  SegmentPricesRequest,
  SegmentPricesResponse,
} from '@/types'
import api from '@/utils/api/api'

type RequestOptions = {
  signal?: AbortSignal
}

export const priceSegmentsApi = {
  getPriceSegments: async (
    client: string | undefined,
    options?: RequestOptions
  ) => {
    const { data } = await api.get<PriceSegmentOptions>(
      '/nomenclatures/price-segments',
      { params: client ? { client } : undefined, signal: options?.signal }
    )
    return data
  },
  getSegmentPrices: async (
    request: SegmentPricesRequest,
    options?: RequestOptions
  ) => {
    const { data } = await api.post<SegmentPricesResponse>(
      '/nomenclatures/segment-prices',
      request,
      {
        headers: { 'Region-Bank': DEFAULT_REGION_BANK_HEADER_VALUE },
        signal: options?.signal,
      }
    )
    return data
  },
}
